import {isMeiYa} from './productUtil'

export const dicInvoiceTypeMap = new Map([
	[1, '增值税专票'],
	[2, '增值税普票'],
])

export const dicInvoiceType = [
	{
		label: '增值税普票',
		value: '2',
	},
	{
		label: '增值税专票',
		value: '1',
	},
]

export const dicInvoiceTypeNumber = [
	{
		label: '增值税普票',
		value: 2,
	},
	{
		label: '增值税专票',
		value: 1,
	},
]

//开票状态:1-;2-普票开具中;3-专票审核驳
// 回;5-专票审核通过;6-已完成;7-作废
export const dicInvoiceStatus = [
	{
		label: '待审核(专票)',
		value: '1',
	},
	{
		label: '普票开具中',
		value: '2',
	},
	{
		label: '专票审核驳回',
		value: '3',
	},
	{
		label: '专票审核通过',
		value: '5',
	},
	{
		label: '已完成',
		value: '6',
	},
	{
		label: '作废',
		value: '7',
	},
]

export const dicGroupList = [
	{
		group_code: 1,
		group_name: '中国人民财产保险股份有限公司',
	},
	{
		group_code: 2,
		group_name: '中国平安财产保险股份有限公司',
	},
	{
		group_code: 3,
		group_name: '中国太平洋保险股份有限公司',
	},
	{
		group_code: 4,
		group_name: '中国人寿财产保险股份有限公司',
	},
	{
		group_code: 5,
		group_name: '亚太财产保险有限公司',
	},
	{
		group_code: 6,
		group_name: '鼎和财产保险股份有限公司',
	},
	{
		group_code: 7,
		group_name: '泰康在线财产保险股份有限公司',
	},
	{
		group_code: 8,
		group_name: '中国大地财产保险股份有限公司',
	},
	{
		group_code: 9,
		group_name: '阳光财产保险有限公司',
	},
	{
		group_code: 10,
		group_name: '中华联合财产保险股份有限公司',
	},
	{
		group_code: 11,
		group_name: '天安财产保险股份有限公司',
	},
	{
		group_code: 15,
		group_name: '申能财产保险股份有限公司',
	},
]

//结算方式
export const dicSettleType = [
	{
		label: '服务对公',
		value: 'PUBLIC',
	},
	{
		label: '中介对公',
		value: 'INTER',
	},
	{
		label: '第三方清分',
		value: 'PRIVATE',
	},
	{
		label: '代理人佣金',
		value: 'AGENT',
	},
]

//由于新市民根据保险公司控制可投产品，需要清理地区或者工号！！！
// 新增产品需要加数据！！！！
export const dicXsmAbleProduct = {
	1: [],
	2: [],
	3: [16, 19],
	4: [],
	5: [],
	6: [],
	7: [],
	8: [30, 38],
	9: [23, 24, 25],
	10: [26, 27],
	11: [],
	15: [56, 57, 58],
}

//获取涉高数据
export function getHighContent(workType, insureType) {
	// 美亚是否扩展高处作业保障 扩展和不扩展
	//其他是否涉高，涉高和不涉高
	return workType === '1' ? (isMeiYa(insureType) ? '扩展' : '涉高') : isMeiYa(insureType) ? '不扩展' : '不涉高'
}
